module.exports = __webpack_public_path__ + "static/img_9741-1fd8216d6e061c0fc8e36b5cdb341870.webp";